<template>
  <div class="content cf-wrap">
    <fundraise-menu>
      <template slot="title">
        <div>Giving Forms</div>
        <p class="text-lg">Create custom donation forms that you can use to accept donations from supporters</p>
      </template>
    </fundraise-menu>

    <div class="impact-content">
      <div class="header px-8 md:px-4 pt-4">
        <div class="row">
          <div class="col-sm-6">
            <h1 v-if="!loading && donationFlows.length">You have <span class="txt-blue">{{donationFlows.length}}</span>
              Giving Forms</h1>
          </div>
          <div class="col-sm-6 text-right">
            <a href="#"
               v-on:click.prevent="createDonationFlow"
               class="btn btn-sm"><span class="plus-icon"></span>Create New
            </a>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4">
        <div class="w-4/5 xl:w-4/6 lg:w-full pr-5 lg:pr-0">
          <div class="s-block shadow-md">
            <div class="s-block-header">Giving Forms</div>
            <div class="s-block-body sbd-fundraise" v-if="activeCharityInfo">

              <table v-if="!loading && donationFlows.length" class="table">
                <tr>
                  <th class="w-8/12 sm:w-3/5">Name</th>
                  <th class="w-3/12 sm:w-1/5">Link</th>
                  <th class="w-1/12 sm:w-1/5">Actions</th>
                </tr>
                <tr v-for="flow in donationFlows"
                    :key="flow.id"
                >
                  <td style="text-align: left">{{flow.name}}
                    <span v-if="flow.is_default" class="guest-pill">Default</span>
                    <span v-if="flow.archived" class="guest-pill guest-pill-archived">Archived</span>
                  </td>
                  <td>
                    <a v-if="flow.is_default" :href="'/donate' | webAppLink(activeCharityInfo)"
                       target="_blank">/wv2/donate</a>
                    <a v-else
                       target="_blank"
                       :href="`/donate?checkout=${flow.id}` | webAppLink(activeCharityInfo)">/wv2/donate?checkout={{flow.id}}</a>
                  </td>
                  <td class="actions-icons">
                    <el-dropdown trigger="click"
                                 @command="handleCommand"
                    >
                      <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                        <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="['edit', flow]"><font-awesome-icon :icon="['fa', 'edit']"/> Edit</el-dropdown-item>
                        <el-dropdown-item :command="['preview', flow]"><font-awesome-icon :icon="['fa', 'eye']"/> Preview</el-dropdown-item>
                        <el-dropdown-item :command="['duplicate', flow]"><font-awesome-icon :icon="['fa', 'copy']"/> Duplicate</el-dropdown-item>
                        <el-dropdown-item v-if="!flow.is_default" :command="['make-default', flow]"><font-awesome-icon :icon="['fa', 'check-circle']"/> Make Default</el-dropdown-item>
                        <el-dropdown-item v-else :command="['remove-default', flow]"><font-awesome-icon :icon="['fa', 'times-circle']"/> Remove as Default</el-dropdown-item>
                        <el-dropdown-item v-if="!flow.archived && !flow.is_default" :command="['archive', flow]"><font-awesome-icon :icon="['fa', 'archive']"/> Archive</el-dropdown-item>
                        <el-dropdown-item v-else-if="!flow.is_default" :command="['unarchive', flow]"><font-awesome-icon :icon="['fa', 'box-open']"/> Unarchive</el-dropdown-item>
                        <el-dropdown-item :command="['delete', flow]"><font-awesome-icon :icon="['fa', 'trash-alt']"/> Delete</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="btn-wrap">
                    <div class="btn-wrap">
                      <a class="btn btn-sm"
                         @click.prevent="createDonationFlow"
                         href="#"
                         style="margin-left: 0; padding: 11px 12px;">+ Add</a></div>
                  </td>
                </tr>
              </table>

              <div v-else-if="!loading" class="empty-placeholder">
                <img :src="require('../../assets/paceholders/11.svg')" alt="No results">
                <h3>No Giving Forms Yet</h3>
              </div>

            </div>
          </div>
        </div>
        <div class="w-1/5 xl:w-2/6 lg:w-full">
          <div class="d-block shadow-md left-sidebar" style="position: relative">
            <div class="faq-list rounded-t-md">
              <div>
                <h3><a href="http://help.harnessapp.com/en/articles/4235800-what-are-checkouts"
                       target="_blank"><img
                    :src="require('../ImpactPosts/messages-icon.svg')" alt="m-i">What are Giving Forms?</a>
                </h3>
                <p class="info">Checkouts are customizable donation forms that you can use to accept
                  donations from
                  supporters.</p>
              </div>

            </div>
            <ul class="faq-links">
              <li><a href="http://help.harnessapp.com/en/articles/4235886-checkout-faqs"
                     target="_blank">Frequently Asked Questions</a>
              </li>
              <li><a
                  href="http://help.harnessapp.com/en/articles/4235804-what-is-my-default-checkout"
                  target="_blank">What is my “Default” Giving Form?</a>
              </li>
              <li><a href="http://help.harnessapp.com/en/articles/4235809-examples-of-donation-checkouts"
                     target="_blank">Can you show me examples?</a>
              </li>
              <li><a href="http://help.harnessapp.com/en/collections/2448825-fundraise#checkouts"
                     target="_blank" class="visit">Learn More</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>


    <v-dialog/>

    <v-modal :width="600"
             :height="'75%'"
             name="add-cf">

      <div
          class="cf-modal-wrap"
          v-if="editor.active"
      >
        <div class="modal-header">
          <a @click="!editor.disabled && cancelEdit()"
             style="float: right"
             href="#"
             aria-label="Close"
          >
            <font-awesome-icon :icon="['fas', 'times']"/>
          </a>
          <div v-if="editor.isCreatingNewDonationFlow" class="modal-title h5">New Checkout</div>
          <div v-else class="modal-title h5">Edit Checkout</div>

          <div v-for="(error, index) in editor.errors"
               :key="index"
               class="toast toast-error my-1">
            <button v-if="false"
                class="btn btn-clear float-right"
                @click.prevent="editor.errors.splice(index, 1)"
            ></button>
            {{error}}
          </div>

          <ul class="tab tab-block">
            <li
                class="tab-item"
                :class="{active: editor.activePage === 'general'}"
            >
              <a class="c-hand" @click.prevent="editor.activePage = 'general'">General</a>
            </li>
            <li
                class="tab-item"
                :class="{active: editor.activePage === 'donation'}"
            >
              <a class="c-hand" @click.prevent="editor.activePage = 'donation'">Donation</a>
            </li>
            <li
                class="tab-item"
                :class="{active: editor.activePage === 'harness_fields'}"
            >
              <a class="c-hand" @click.prevent="editor.activePage = 'harness_fields'">Contact Info</a>
            </li>
            <li
                class="tab-item"
                :class="{active: editor.activePage === 'custom_fields'}"
            >
              <a class="c-hand" @click.prevent="editor.activePage = 'custom_fields'">Custom Fields</a>
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <div>
            <form>
              <div :disabled="editor.disabled">
                <div id="general-tab" v-if="editor.activePage === 'general'">
                  <h1 class="text-xl font-bold my-2.5">General</h1>
                  <form-input-text
                      v-model="editor.donationFlow.name"
                      :label="'Checkout Name'"
                  ></form-input-text>

                  <h2 class="text-xl txt-blue font-bold mt-7 mb-4">Footer</h2>

                  <div class="form-group">
                    <label class="form-switch">
                      <input
                          type="checkbox"
                          :checked="useDefaultFooterText"
                          @change="toggleCustomFooterText"
                      >
                      <i class="form-icon"></i> Use the default "⚡ Powered by
                      <b><a style="color: rgb(39 39 39);" target="_blank" href="https://harnessapp.com/">Harness</a>"</b> Footer
                    </label>
                  </div>

                  <div v-if="!useDefaultFooterText">
                    <quill-editor
                        class="new-msg"
                        v-model="customFooterText"
                        :options="{
                      ...quillOption,
                      placeholder: '⚡ Powered by &lt;strong&gt;Harness&lt;/strong&gt;',
                    }"
                        ref="footerEditor"
                    />
                  </div>

                </div>

                <div id="donation-tab" v-if="editor.activePage === 'donation'">
                  <h1 class="text-xl font-bold my-2.5">Donation</h1>
                  <label for="d-method">Default Donation Type</label>
                  <select
                      id="d-method"
                      class="form-control"
                      v-model="editorFlowProps.donation.default_method"
                  >
                    <option
                        v-for="method in editorFlowProps.donation.allowed_methods"
                        :key="method"
                        :value="method"
                    >{{method.replace('one_time', 'One-Time').replace('roundup', 'Round-Ups').replace('monthly',
                      'Monthly')}}
                    </option>
                  </select>

                  <h2 class="text-xl txt-blue font-bold mt-7 mb-4">One-Time</h2>
                  <div class="form-group">
                    <input class="hidden"
                           type="checkbox"
                           ref="ch_one_time"
                           v-model="editorFlowProps.donation.allowed_methods"
                           value="one_time">

                    <el-switch :value="editorFlowProps.donation.allowed_methods.indexOf('one_time') !== -1"
                               v-on:change="$refs.ch_one_time.click()"
                               active-text="Enabled"
                    ></el-switch>
                  </div>


                  <div v-if="editorFlowProps.donation.allowed_methods.indexOf('one_time') > -1">
                    <div class="form-group">

                      <el-switch v-model="editorFlowProps.donation.allow_guest_checkout"
                                 active-text="Allow Guest Checkout"
                      ></el-switch>


                      <h5 class="text-sm font-bold my-3">Custom Amount</h5>


                      <el-switch v-model="editorFlowProps.donation.giving_amounts.one_time.custom_amount.enabled"
                                 active-text="Enabled"
                      ></el-switch>


                      <div class="mt-2 form-item">
                        <label class="form-label">Minimum Donation Amount</label>
                        <div class="dollar-input-wrap">
                          <input
                              type="number"
                              v-model.number="editorFlowProps.donation.giving_amounts.one_time.custom_amount.min_cents"
                              class="form-control"
                              min="1"
                              max="999999"
                              :disabled="!editorFlowProps.donation.giving_amounts.one_time.custom_amount.enabled"
                          /></div>
                      </div>


                      <div class="form-item">
                        <label class="form-label">Maximum Donation Amount</label>
                        <div class="dollar-input-wrap">
                          <input
                              type="number"
                              v-model.number="editorFlowProps.donation.giving_amounts.one_time.custom_amount.max_cents"
                              class="form-control"
                              min="1"
                              max="999999"
                              :disabled="!editorFlowProps.donation.giving_amounts.one_time.custom_amount.enabled"
                          />
                        </div>
                      </div>

                    </div>

                    <h5 class="text-sm font-bold my-3">Suggested Amounts | One-Time</h5>

                    <div
                        class="input-group"
                        v-for="(suggestion, index) in editorFlowProps.donation.giving_amounts.one_time.suggested_amounts"
                        :key="index"
                    >
                      <form-input-radio-boolean
                          v-model="suggestion.amount"
                          :checked="suggestion.default"
                          :label="'Default'"
                          name="one-time-suggestion-default"
                          :id="'one-time-suggestion-' + suggestion.amount"
                          @input="updateRadioGroup(editorFlowProps.donation.giving_amounts.one_time.suggested_amounts, 'amount', 'default', $event)"
                      ></form-input-radio-boolean>

                      <input
                          type="number"
                          v-model.number="suggestion.amount"
                          class="form-control"
                          min="1"
                          max="999999"
                      />

                      <button
                          class="btn btn-sm"
                          @click.prevent="editorFlowProps.donation.giving_amounts.one_time.suggested_amounts.splice(index, 1)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                      </button>
                    </div>

                    <div class="btn-wrap">
                      <button
                          @click.prevent="addNewSuggestedDonationAmount('one_time')"
                          class="btn btn-sm"
                          :disabled="editorFlowProps.donation.giving_amounts.one_time.suggested_amounts.length >= 4"
                      >
                        Add Suggestion
                      </button>
                    </div>
                  </div>

                  <ImpactAmountsBlock
                      v-if="editorFlowProps.donation.allowed_methods.indexOf('one_time') > -1"
                      :impactAmounts="impactAmounts"
                      v-model="editorFlowProps.donation.giving_amounts.one_time.donation_impacts"
                  ></ImpactAmountsBlock>

                  <hr>

                  <h2 class="text-xl txt-blue font-bold mt-7 mb-4">Monthly</h2>

                  <div class="form-group">
                    <input class="hidden"
                           type="checkbox"
                           ref="ch_monthly"
                           v-model="editorFlowProps.donation.allowed_methods"
                           value="monthly">

                    <el-switch :value="editorFlowProps.donation.allowed_methods.indexOf('monthly') !== -1"
                               v-on:change="$refs.ch_monthly.click()"
                               active-text="Enabled"
                    ></el-switch>
                  </div>

                  <div v-if="editorFlowProps.donation.allowed_methods.indexOf('monthly') > -1">
                    <div class="form-group">
                      <h5 class="text-sm font-bold my-3">Custom Amount</h5>


                      <el-switch v-model="editorFlowProps.donation.giving_amounts.monthly.custom_amount.enabled"
                                 active-text="Enabled"
                      ></el-switch>


                      <div class="form-item">
                        <label class="form-label">Minimum Donation Amount</label>
                        <div class="dollar-input-wrap">
                          <input
                              type="number"
                              v-model.number="editorFlowProps.donation.giving_amounts.monthly.custom_amount.min_cents"
                              class="form-control"
                              min="1"
                              max="999999"
                              :disabled="!editorFlowProps.donation.giving_amounts.monthly.custom_amount.enabled"
                          />
                        </div>
                      </div>

                      <div class="form-item">
                        <label class="form-label">Maximum Donation Amount</label>
                        <div class="dollar-input-wrap">
                          <input
                              type="number"
                              v-model.number="editorFlowProps.donation.giving_amounts.monthly.custom_amount.max_cents"
                              class="form-control"
                              min="1"
                              max="999999"
                              :disabled="!editorFlowProps.donation.giving_amounts.monthly.custom_amount.enabled"
                          />
                        </div>
                      </div>
                    </div>

                    <h5 class="text-sm font-bold my-3">Suggested Amounts | Monthly</h5>

                    <div
                        class="input-group"
                        v-for="(suggestion, index) in editorFlowProps.donation.giving_amounts.monthly.suggested_amounts"
                        :key="index"
                    >
                      <form-input-radio-boolean
                          v-model.number="suggestion.amount"
                          :checked="suggestion.default"
                          :label="'Default'"
                          name="monthly-suggestion-default"
                          :id="'monthly-suggestion-' + suggestion.amount"
                          @input="updateRadioGroup(editorFlowProps.donation.giving_amounts.monthly.suggested_amounts, 'amount', 'default', $event)"
                      ></form-input-radio-boolean>

                      <input
                          type="number"
                          v-model.number="suggestion.amount"
                          class="form-control"
                          min="1"
                          max="999999"
                      />

                      <button
                          class="btn btn-sm"
                          @click.prevent="editorFlowProps.donation.giving_amounts.monthly.suggested_amounts.splice(index, 1)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                      </button>

                    </div>

                    <div class="btn-wrap">
                      <button
                          @click.prevent="addNewSuggestedDonationAmount('monthly')"
                          class="btn btn-sm"
                          :disabled="editorFlowProps.donation.giving_amounts.monthly.suggested_amounts.length >= 4"
                      >
                        Add Suggestion
                      </button>
                    </div>
                  </div>

                  <ImpactAmountsBlock v-if="editorFlowProps.donation.allowed_methods.indexOf('monthly') > -1"
                      :impactAmounts="impactAmounts"
                      v-model="editorFlowProps.donation.giving_amounts.monthly.donation_impacts"
                  ></ImpactAmountsBlock>

                  <hr>

                  <h2 class="text-xl txt-blue font-bold mt-7 mb-4">Round-Ups</h2>

                  <div class="form-group">
                    <input class="hidden"
                           type="checkbox"
                           ref="ch_roundup"
                           v-model="editorFlowProps.donation.allowed_methods"
                           value="roundup">

                    <el-switch :value="editorFlowProps.donation.allowed_methods.indexOf('roundup') !== -1"
                               v-on:change="$refs.ch_roundup.click()"
                               active-text="Enabled"
                    ></el-switch>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">Campaigns</h3>

                    <div class="form-group">
                      <label>
                      <el-switch v-model="editorFlowProps.donation.campaigns.selection_required"></el-switch>
                          <span class="el-switch__label el-switch__label--right "
                                :class="{'is-active':editorFlowProps.donation.campaigns.selection_required}"
                                aria-hidden="true">Require Campaign (<span class="txt-red">Removes </span> "Area of Greatest Need")</span>
                      </label>
                    </div>

                    <div class="form-group">
                      <input class="hidden"
                             type="checkbox"
                             ref="ch_all_cmp"
                             :checked="editorFlowProps.donation.campaigns.options === 'all'"
                             @input="toggleCampaignOptions"
                      >
                      <el-switch :value="editorFlowProps.donation.campaigns.options === 'all'"
                                 v-on:change="$refs.ch_all_cmp.click()"
                                 active-text="All campaigns"
                      ></el-switch>
                    </div>


                    <div v-if="editorFlowProps.donation.campaigns.options !== 'all'"
                         v-for="campaign in allCampaigns"
                         :key="campaign.id"
                         class="form-group"
                    >

                      <div v-if="!hasCampaignEnded(campaign)">
                        <input type="checkbox"
                               class="hidden"
                               :ref="`ch_cmp_${campaign.id}`"
                               :value="campaign.id"
                               :checked="isCampaignSelected(campaign.id)"
                               @input="updateSelectedCampaigns"
                        >
                        <el-switch :value="isCampaignSelected(campaign.id)"

                                   v-on:change="$refs[`ch_cmp_${campaign.id}`][0].click()"

                                   :active-text="campaign.name"
                        ></el-switch>
                      </div>

                    </div>

                    <div class="form-group">
                      <select
                          class="form-control"
                          v-model="editorFlowProps.donation.campaigns.default"
                      >
                        <option disabled>Select default campaign</option>
                        <option :value="null">No default campaign</option>
                        <option
                            v-for="campaign in allowedCampaigns"
                            :key="campaign.id"
                            :value="campaign.id"
                        >{{campaign.name || getCampaign(campaign.id).name}}
                        </option>
                      </select>
                    </div>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">Smart Ask</h3>

                    <div class="form-group">
                      <el-switch v-model="editorFlowProps.donation.smart_ask.enabled"
                                 active-text="Enabled"
                      ></el-switch>
                    </div>

                    <div v-if="editorFlowProps.donation.smart_ask.enabled">
                      <form-input-file-upload
                          v-model="editorFlowProps.donation.smart_ask.image_url"
                          :label="'Change the SmartAsk Image'"
                          :placeholder="'image.png'"
                          :disabled="!editorFlowProps.donation.smart_ask.enabled"
                      ></form-input-file-upload>

                      <label for="impact_multiplier" class="form-label">Impact Multiplier</label>
                      <input
                          type="number"
                          v-model.number="editorFlowProps.donation.smart_ask.impact_multiplier"
                          class="form-control"
                          min="1"
                          max="12"
                          id="impact_multiplier"
                          step="0.5"
                          :disabled="!editorFlowProps.donation.smart_ask.enabled"
                      />
                    </div>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">Cover Fees</h3>

                    <div class="form-group">

                      <el-switch class="mr-3" v-model="editorFlowProps.donation.cover_fees.enabled"
                                 v-on:change="coverFeesUpdate"
                                 active-text="Enabled"
                      ></el-switch>


                      <el-switch v-model="editorFlowProps.donation.cover_fees.default"
                                 :disabled="!editorFlowProps.donation.cover_fees.enabled"
                                 active-text="Default to checked"
                      ></el-switch>
                    </div>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">In Honor/In Memory</h3>

                    <div class="form-group">

                      <el-switch class="mr-3" v-model="editorFlowProps.donation.in_honor.enabled"
                                 active-text="Enabled"
                      ></el-switch>

                      <el-switch v-model="editorFlowProps.donation.in_honor.message.required"
                                 :disabled="!editorFlowProps.donation.in_honor.enabled"
                                 active-text="Require a message"
                      ></el-switch>
                    </div>

                    <div v-if="editorFlowProps.donation.in_honor.enabled" class="form-group">
                      <h5 class="text-sm font-bold my-3">Delivery Method Options</h5>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_email"
                               v-model="editorFlowProps.donation.in_honor.delivery_methods"
                               value="email">

                        <el-switch :value="editorFlowProps.donation.in_honor.delivery_methods.indexOf('email') !== -1"
                                   v-on:change="$refs.ch_email.click()"
                                   active-text="Email"
                        ></el-switch>
                      </div>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_letter"
                               v-model="editorFlowProps.donation.in_honor.delivery_methods"
                               value="letter">

                        <el-switch :value="editorFlowProps.donation.in_honor.delivery_methods.indexOf('letter') !== -1"
                                   v-on:change="$refs.ch_letter.click()"
                                   active-text="Letter"
                        ></el-switch>
                      </div>

                    </div>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">Donation Note</h3>
                    <div class="form-group">
                      <el-switch v-model="editorFlowProps.donation.note.enabled"
                                 active-text="Enabled"
                      ></el-switch>
                    </div>
                  </div>

                  <hr>

                  <div>
                    <h3 class="text-lg leading-6 my-2 font-semibold">Thank You Page</h3>

                    <div class="form-item">
                      <label class="form-label" for="thanks-message">Message</label>
                      <textarea
                          v-model="editorFlowProps.donation.thank_you.message"
                          class="form-control"
                          id="thanks-message"
                          placeholder="Thank you for your donation!"
                          rows="3"
                      ></textarea>
                    </div>

                    <div class="form-group form-group-actions">
                      <label class="form-label">Actions & Buttons</label>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_share_twitter"
                               v-model="editorFlowProps.donation.thank_you.actions"
                               value="share_twitter">

                        <el-switch :value="editorFlowProps.donation.thank_you.actions.indexOf('share_twitter') !== -1"
                                   v-on:change="$refs.ch_share_twitter.click()"
                                   active-text="Share on Twitter"
                        ></el-switch>
                      </div>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_share_facebook"
                               v-model="editorFlowProps.donation.thank_you.actions"
                               value="share_facebook">

                        <el-switch :value="editorFlowProps.donation.thank_you.actions.indexOf('share_facebook') !== -1"
                                   v-on:change="$refs.ch_share_facebook.click()"
                                   active-text="Share on Facebook"
                        ></el-switch>
                      </div>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_complete_profile"
                               v-model="editorFlowProps.donation.thank_you.actions"
                               value="complete_profile">

                        <el-switch :value="editorFlowProps.donation.thank_you.actions.indexOf('complete_profile') !== -1"
                                   v-on:change="$refs.ch_complete_profile.click()"
                                   active-text="Complete Profile"
                        ></el-switch>
                      </div>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_view_receipt"
                               v-model="editorFlowProps.donation.thank_you.actions"
                               value="view_receipt">

                        <el-switch :value="editorFlowProps.donation.thank_you.actions.indexOf('view_receipt') !== -1"
                                   v-on:change="$refs.ch_view_receipt.click()"
                                   active-text="View Receipt"
                        ></el-switch>
                      </div>

                      <div class="form-group">
                        <input class="hidden"
                               type="checkbox"
                               ref="ch_donation_history"
                               v-model="editorFlowProps.donation.thank_you.actions"
                               value="donation_history">

                        <el-switch :value="editorFlowProps.donation.thank_you.actions.indexOf('donation_history') !== -1"
                                   v-on:change="$refs.ch_donation_history.click()"
                                   active-text="Donation History"
                        ></el-switch>
                      </div>

                    </div>
                  </div>
                </div>

                <div :id="`donation-tab`" v-if="editor.activePage === 'harness_fields'">
                  <h1 class="text-xl font-bold my-2.5">Contact Info</h1>
                  <h2 class="text-xl txt-blue font-bold mt-7 mb-4">Ask donors for:</h2>

                  <div class="form-group">
                    <h5 class="text-sm font-bold my-3">Phone Number</h5>

                    <div class="form-group">
                      <el-switch class="mr-3" v-model="editorFlowProps.harness_fields.phone_number.enabled"
                                 active-text="Enabled"
                      ></el-switch>

                      <label style="vertical-align: text-top">

                        <input type="checkbox"
                               v-model="editorFlowProps.harness_fields.phone_number.required"
                               :disabled="!editorFlowProps.harness_fields.phone_number.enabled">

                        <i class="form-icon"></i> Required
                      </label>
                    </div>
                  </div>

                  <div class="form-group" style="margin-top: 15px">
                    <h5 class="text-sm font-bold my-3">Mailing Address</h5>
                    <div class="form-group">
                      <el-switch class="mr-3" v-model="editorFlowProps.harness_fields.address.enabled"
                                 active-text="Enabled"
                      ></el-switch>

                      <label class="form-switch form-inline text-left">
                        <input type="checkbox"
                               v-model="editorFlowProps.harness_fields.address.required"
                               :disabled="!editorFlowProps.harness_fields.address.enabled">

                        <i class="form-icon"></i> Required
                      </label>
                    </div>
                  </div>

                  <div v-if="editorFlowProps.harness_fields.employment"
                       class="form-group"
                       style="margin-top: 15px">
                    <h5 class="text-sm font-bold my-3">Employer Matching</h5>
                    <div class="form-group">
                        <el-switch class="mr-3" v-model="editorFlowProps.harness_fields.employment.enabled"
                                   active-text="Enabled"
                        ></el-switch>

                      <label class="form-switch form-inline text-left">
                        <input type="checkbox"
                               v-model="editorFlowProps.harness_fields.employment.required"
                               :disabled="!editorFlowProps.harness_fields.employment.enabled">

                        <i class="form-icon"></i> Required
                      </label>
                    </div>
                  </div>
                </div>

                <div :id="`donation-tab`" v-if="editor.activePage === 'custom_fields'">
                  <h1 class="text-xl font-bold my-2.5">Custom Fields</h1>
                  <p>Choose the custom field questions you'd like asked during this checkout:</p>
                  <div id="selected-custom-fields" class="my-2 d-block-list">
                    <h4 class="text-base leading-5 my-2 font-semibold">Selected</h4>

                    <table
                        class="table"
                        v-if="editorFlowProps.custom_fields.fields.length"
                    >
                      <thead>
                      <tr>
                        <th style="width: 150px">Required</th>
                        <th>Name</th>
                        <th style="width: 45px">Remove</th>
                      </tr>
                      </thead>

                      <draggable
                          v-model="editorFlowProps.custom_fields.fields"
                          tag="tbody"
                      >
                        <tr
                            v-for="(field, index) in editorFlowProps.custom_fields.fields"
                            :key="field.id"
                            class="custom-field-row"
                        >
                          <td>
                            <el-switch v-model="field.required"></el-switch>
                          </td>
                          <td class="c-move">
                            {{ getCustomField(field.id).properties.name }}
                          </td>
                          <td>
                            <button
                                class="btn btn-sm"
                                @click.prevent="removeCustomField(index)"
                            >
                              <font-awesome-icon :icon="['fas', 'minus']"/>
                            </button>
                          </td>
                        </tr>
                      </draggable>
                    </table>

                    <div class="empty" v-else>
                      <p class="empty-title">--</p>
                    </div>
                  </div>

                  <hr>

                  <div id="available-custom-fields" class="my-2 d-block-list">
                    <h4 class="text-base leading-5 my-2 font-semibold">Available</h4>

                    <table
                        class="table"
                        v-if="unselectedActiveCustomFields.length"
                    >
                      <thead>
                      <tr>
                        <th style="width: 150px">Type</th>
                        <th>Name</th>
                        <th style="width: 45px">Select</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="field in unselectedActiveCustomFields"
                          :key="field.id"
                      >
                        <td>{{field.properties.type}}</td>
                        <td>{{field.properties.name}}</td>
                        <td>
                          <button
                              class="btn btn-sm"
                              @click.prevent="addCustomField(field)"
                          >
                            <font-awesome-icon :icon="['fas', 'plus']"/>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="empty" v-else>
                      <p class="empty-title">No Custom Fields Available</p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right btn-wrap" :disabled="editor.disabled">
            <button class="btn btn-sm btn-cancel" @click.prevent="cancelEdit">Cancel</button>
            <button class="btn btn-sm" @click.prevent="save">Save</button>
          </div>
        </div>
      </div>

    </v-modal>

  </div>
</template>

<script>

  import 'quill/dist/quill.core.css' // import styles
  import 'quill/dist/quill.snow.css' // for snow theme
  import 'quill/dist/quill.bubble.css' // for bubble theme
  import { quillEditor } from 'vue-quill-editor'

  import FundraiseMenu from './menu.vue';
  import {customFields, donationFlow as DonationFlow, ImpactAmounts, putOrganizationSettings} from '../../utils/api';
  import FormInputText from './Controls/FormInputText';
  import FormInputRadioBoolean from './Controls/FormInputRadioBoolean';
  import FormInputFileUpload from './Controls/FormInputFileUpload';
  import ImpactAmountsBlock from './Controls/ImpactAmounts';
  import Switches from 'vue-switches';
  import {mapActions, mapState} from 'vuex';
  import draggable from 'vuedraggable';
  require('quill-emoji')
  require('quill-emoji/dist/quill-emoji.css')

  const striptags = require('striptags');

  const moment = require('moment');

  export default {
    name: 'DonationAsks',
    mounted() {
      this.updateFlows();
    },
    metaInfo: {
      title: 'Fundraise - Checkouts',
    },
    components: {
      ImpactAmountsBlock,
      FundraiseMenu,
      Switches,
      FormInputText,
      FormInputRadioBoolean,
      FormInputFileUpload,
      draggable,
      quillEditor
    },
    methods: {
      ...mapActions('campaigns', [
        'updateCampaigns',
      ]),
      handleCommand([command, payload]) {
        switch (command){
          case 'preview':
            window.open(this.$options.filters.webAppLink(`/donate?checkout=${payload.id}`, this.activeCharityInfo), '_blank').focus();
            break;
          case 'duplicate':
            this.copyDonationFlow(payload)
            break;
          case 'edit':
            this.editDonationFlow(payload)
            break;
          case 'make-default':
            this.makeDefault(payload)
            break;
          case 'remove-default':
            this.makeDefault(null)
            break;
          case 'delete':
            this.promptDeleteDonationFlow(payload)
            break;
          case 'unarchive':
            this.unarchiveDonationFlow(payload)
            break
          case 'archive':
            this.archiveDonationFlow(payload)
            break
        }
      },
      coverFeesUpdate(){
        this.$nextTick(()=>{
          if(!this.editorFlowProps.donation.cover_fees.enabled){
            this.editorFlowProps.donation.cover_fees.default = false
          }
        });
      },
      toggleCustomFooterText (event) {
        const checked = event.target.checked;

        this.editorFlowProps.donation.display.footer.text = checked ? null : "⚡ Powered by " +
            " <a href=\"https://harnessapp.com/\" target=\"_blank\">Harness</a>";

      },
      updateFlows() {
        ImpactAmounts.getImpactAmounts(this.activeCharityId).then(impactAmounts => {
          this.impactAmounts = impactAmounts;
        });

        this.updateCampaigns({charity_id: this.activeCharityId});

        customFields.getAll(this.activeCharityId).then(cf => {
          this.customFields = cf;
        });

        DonationFlow.getAll(this.activeCharityId).then(df => {
          this.donationFlows = df;
          this.loading = false;
        });
      },
      normalizePrice(flow, rate = .01) {
        flow = JSON.parse(JSON.stringify(flow));

        /**
         * Multiply by `rate` and round the result to the proper 2-decimal or int value depending on the value of `rate`,
         * so as to assure the result is either a whole number (cents) or a 2-decimal value (dollars).
         */
        const safeRound = (v, r) => {
          // If r is less than one (eg: 0.01), then the value needs to be rounded to a 2-decimal value.
          if (r < 1) {
            return (v * r).toFixed(2);
          }
          // Otherwise, multiply and round to ensure no decimal places
          else {
            return Math.round(v * r);
          }
        };

        const n = (p) => {
          if (p.custom_amount) {
            if (p.custom_amount.min_cents) {
              p.custom_amount.min_cents = safeRound(p.custom_amount.min_cents, rate);
            }
            if (p.custom_amount.max_cents) {
              p.custom_amount.max_cents = safeRound(p.custom_amount.max_cents, rate);
            }
          }
          if (p.suggested_amounts && p.suggested_amounts.length) {
            for (let i = 0; i < p.suggested_amounts.length; i++) {
              if (p.suggested_amounts[i].amount) {
                p.suggested_amounts[i].amount = safeRound(p.suggested_amounts[i].amount, rate);
              }
            }
          }

        };

        if (flow.properties.donation && flow.properties.donation.giving_amounts) {
          n(flow.properties.donation.giving_amounts.one_time);
          n(flow.properties.donation.giving_amounts.monthly);
        }

        return flow;
      },
      makeDefault(donationFlow) {
        putOrganizationSettings({default_flow_id: donationFlow && donationFlow.id || null}).then(() => {
          this.updateFlows();
          this.$message(`Default checkout changed`);
        }).catch(err => alert(err.error));
      },
      copyDonationFlow(donationFlow) {
        let df = this.normalizePrice(donationFlow, 1);
        df = {name: df.name + ' (copy)', properties: df.properties};

        DonationFlow.create(df, this.activeCharityId).then(() => {
          this.updateFlows();
          this.$message(`New checkout "${df.name}" created`);
        }).catch(err => alert(err.error));
      },
      createDonationFlow() {
        this.editor.active = true;
        this.editor.disabled = false;
        this.editor.isCreatingNewDonationFlow = true;
        this.editor.donationFlow = this.normalizePrice(this.getDonationFlowTemplate());
        this.editor.donationFlowBeforeEdits = this.normalizePrice(this.getDonationFlowTemplate());
        this.editor.activePage = 'general';
        this.editor.errors = [];
        this.$modal.show('add-cf');
      },
      editDonationFlow(donationFlow) {
        this.editor.active = true;
        this.editor.disabled = false;
        this.editor.isCreatingNewDonationFlow = false;
        this.editor.donationFlow = this.normalizePrice(donationFlow);
        this.editor.activePage = 'general';
        this.editor.errors = [];

        // Perform a deep copy of the donationFlow to save.
        this.editor.donationFlowBeforeEdits = this.normalizePrice(JSON.parse(JSON.stringify(donationFlow)));
        this.$modal.show('add-cf');
      },
      promptDeleteDonationFlow(df) {

        this.$modal.show('dialog', {
          title: 'Delete Checkout',
          'class': 'modal-delete',
          text: `Are you sure you want to delete the checkout:<br>"${df.name}"?`,
          buttons: [
            {
              title: 'No, Cancel',
              default: true,
              handler: () => {
                this.$modal.hide('dialog');
              }
            },
            {
              title: 'Yes, Delete',
              class: 'btn btn-sm btn-delete no-box-shadow',
              handler: () => {
                DonationFlow.delete(df.id, this.activeCharityId).then(() => {
                  this.$modal.hide('dialog');
                  this.$message(`Checkout "${df.name}" deleted`);
                  this.updateFlows();
                }).catch(err => alert(err));
              },
            },
          ],
        });
      },
      save() {
        this.editor.errors = [];
        if(this.editorFlowProps.donation.display.footer.text) {

          this.editorFlowProps.donation.display.footer.text =
              striptags(
                  this.editorFlowProps.donation.display.footer.text
                      .replaceAll(' rel="noopener noreferrer"', ''),
                  ['a', 'em', 'strong']
              );
        }
        if (!this.editorFlowProps.donation.cover_fees.enabled) {
          this.editorFlowProps.donation.cover_fees.default = false
        }


        if (this.editor.isCreatingNewDonationFlow) {
          this.saveNew();
        } else {
          this.saveEdit();
        }
      },
      saveNew() {
        let df = this.normalizePrice(this.editor.donationFlow, 100);

        DonationFlow.create(df, this.activeCharityId).then(() => {
          this.updateFlows();
          this.$message(`New checkout "${df.name}" created`);
          this.closeEditor();
        }).catch(err => {
          if (err.reasons) {
            this.editor.errors = Array.isArray(err.reasons) ? err.reasons : [err.reasons];
          } else if (err.errors) {
            this.editor.errors = Array.isArray(err.errors) ? err.errors : [err.errors];
          } else {
            alert(err);
          }
        });
      },
      filterImpactAmounts(config){
        return config.filter(c =>  this.impactAmounts.find(i => i.id == c.id))
      },
      saveEdit() {
        let df = this.normalizePrice(this.editor.donationFlow, 100);
        df.properties.donation.giving_amounts.one_time.donation_impacts =
            this.filterImpactAmounts(df.properties.donation.giving_amounts.one_time.donation_impacts);

        df.properties.donation.giving_amounts.monthly.donation_impacts =
            this.filterImpactAmounts(df.properties.donation.giving_amounts.monthly.donation_impacts);

        DonationFlow.update(df.id, df, this.activeCharityId).then(() => {
          this.updateFlows();
          this.$message(`Checkout "${df.name}" updated`);
          this.closeEditor();
        }).catch(err => {
          if (err.errors) {
            this.editor.errors = Array.isArray(err.errors) ? err.errors : [err.errors];
          } else {
            alert(err);
          }
        });
      },
      cancelEdit() {
        // Copy the old properties back, discarding any edits.
        Object.assign(this.editor.donationFlow, this.editor.donationFlowBeforeEdits);

        this.closeEditor();
      },

      closeEditor() {
        this.editor.active = false;
        this.editor.disabled = false;
        this.editor.donationFlow = null;
        this.editor.donationFlowBeforeEdits = null;
        this.editor.newFunctionality = '';
        this.editor.activePage = 'general';
        this.editor.errors = [];
        this.$modal.hide('add-cf');
      },

      archiveDonationFlow(field) {
        DonationFlow.archive(field.id, this.activeCharityId).then(() => {
          this.updateFlows();
          this.$message(`Checkout "${field.name}" archived`);
        }).catch(err => alert(err));
      },

      unarchiveDonationFlow(field) {
        DonationFlow.unarchive(field.id, this.activeCharityId).then(() => {
          this.updateFlows();
          this.$message(`Checkout "${field.name}" unarchived`);
        }).catch(err => alert(err));
      },

      getDonationFlowTemplate() {
        return {
          'name': '',
          'properties': {
            'donation': {
              "display": {
                "footer": {
                  "text": null
                }
              },
              'allow_guest_checkout': true,
              'allowed_methods': [
                'one_time',
                'monthly',
                'roundup',
              ],
              'giving_amounts': {
                'one_time': {
                  'custom_amount': {
                    'enabled': true,
                    'min_cents': 100,
                    'max_cents': 99999999,
                  },
                  'suggested_amounts': [
                    {
                      'amount': 1000,
                      'default': false,
                    },
                    {
                      'amount': 2500,
                      'default': false,
                    },
                    {
                      'amount': 5000,
                      'default': true,
                    },
                    {
                      'amount': 10000,
                      'default': false,
                    },
                  ],
                  'donation_impacts': [],
                },
                'monthly': {
                  'custom_amount': {
                    'enabled': true,
                    'min_cents': 100,
                    'max_cents': 99999999,
                  },
                  'suggested_amounts': [
                    {
                      'amount': 1000,
                      'default': false,
                    },
                    {
                      'amount': 2500,
                      'default': false,
                    },
                    {
                      'amount': 5000,
                      'default': true,
                    },
                    {
                      'amount': 10000,
                      'default': false,
                    },
                  ],
                  'donation_impacts': [],
                },
              },
              'campaigns': {
                'options': 'all',
                'selection_required': false,
              },
              'smart_ask': {
                'enabled': true,
                'image_url': null,
                'impact_multiplier': 3.5,
              },
              'cover_fees': {
                'enabled': true,
                'default': true,
              },
              'in_honor': {
                'enabled': true,
                'message': {
                  'required': true,
                },
                'delivery_methods': [
                  'email',
                  'letter',
                ],
              },
              'thank_you': {
                'message': '',
                'actions': [
                  'complete_profile',
                  'view_receipt',
                ],
              },
              'note': {
                'enabled': true,
              },
            },
            'harness_fields': {
              'phone_number': {
                'enabled': true,
                'required': false,
              },
              'address': {
                'enabled': true,
                'required': false,
              },
            },
            'custom_fields': {
              'fields': [],
            },
          },
        };
      },

      addNewSuggestedDonationAmount(donationType) {
        // Find the current max suggestion, then double it,
        // or default to 1000 ($10)
        let newSuggestion = Number(
          this.editor.donationFlow.properties.donation.giving_amounts[donationType].suggested_amounts.reduce(
            (max, sugg) => {
              if (sugg.amount > max) {
                return sugg.amount;
              }
              return max;
            }, 0)) * 2 || 1000;

        this.editor.donationFlow.properties.donation.giving_amounts[donationType].suggested_amounts.push(
          {amount: newSuggestion, default: false});
      },

      /**
       * Called when a radio <input> selection is changed.
       * This is used then the radio inputs are used to set a boolean property
       * to indicate which item is selected within a `group` array of objects.
       * When called, it will mark the object with the given `id` as selected,
       * and all others will have their `selectedProp` set to `false`.
       *
       * The objects in the array are assumed to have a structure of (at least)
       * a unique identifier and a boolean value indicating if that object is selected.
       * Ex: `{id: 123, selected: true}`.
       *
       * @example `updateRadioGroup(group, "id", "selected", 123);`
       * @param group
       * @param idProp
       * @param selectedProp
       * @param id
       */
      updateRadioGroup(group, idProp, selectedProp, id) {
        group.forEach((obj) => {
          obj[selectedProp] = obj[idProp] == id;
        });
      },

      toggleCampaignOptions(event) {
        // Is the "all campaigns" checkbox checked?
        this.editorFlowProps.donation.campaigns.default = null;
        this.editorFlowProps.donation.campaigns.options = event.target.checked ? 'all' : [];

        this.clearDonationCampaignCheckboxes();
      },

      isCampaignSelected(campaignId) {
        const selectedCampaigns = this.editorFlowProps.donation.campaigns.options;

        if (selectedCampaigns === 'all') {
          return true;
        }

        const campaign = selectedCampaigns.find(c => c.id == campaignId);

        return Boolean(campaign);
      },
      updateSelectedCampaigns(event) {
        const checked = event.target.checked;
        const campaignId = Number(event.target.value);

        if (checked) {
          this.editorFlowProps.donation.campaigns.options.push({
            id: campaignId,
          });
        } else {
          const index = this.editorFlowProps.donation.campaigns.options.findIndex(
            campaign => Number(campaign.id) === campaignId);
          this.editorFlowProps.donation.campaigns.options.splice(index, 1);
        }
      },
      /**
       * Since the campaign checkboxes aren't tied to a v-model,
       * we need to manually uncheck all of them if the `options` value is set to "all".
       */
      clearDonationCampaignCheckboxes() {
        // Will be true if set to all campaigns, otherwise will be false.
        const newVal = this.editorFlowProps.donation.campaigns.options === 'all';

        const checkboxes = document.getElementsByClassName('donation-campaign-checkbox');
        for (let i = 0; i < checkboxes.length; i += 1) {
          checkboxes[i].checked = newVal;
        }
      },

      getCampaign(id) {
        return this.allCampaigns.find(campaign => Number(campaign.id) === Number(id));
      },

      addCustomField(field) {
        this.editorFlowProps.custom_fields.fields.push({
          id: field.id,
          required: false,
        });
      },

      removeCustomField(index) {
        this.editorFlowProps.custom_fields.fields.splice(index, 1);
      },

      getCustomField(id) {
        return this.customFields.find(field => field.id == id);
      },

      hasCampaignEnded(campaign) {
        return campaign.endsAt != null && moment(campaign.endsAt).isBefore(/* now */);
      },
    },
    computed: {
      useDefaultFooterText () {
        return this.editorFlowProps.donation.display.footer.text == null;
      },
      customFooterText: {
        get () {
          return this.editorFlowProps.donation.display.footer.text || "";
        },
        // setter
        set (newValue) {
          if (this.editorFlowProps.donation.display.footer.text == null) {
            return;
          }

          this.editorFlowProps.donation.display.footer.text = newValue;
        }
      },
      ...mapState({
        allCampaigns: state => state.campaigns.allCampaigns,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,

      }),

      allowedCampaigns() {

        return this.editorFlowProps.donation.campaigns.options === 'all'
          ? this.allCampaigns : this.editorFlowProps.donation.campaigns.options;
      },

      editorFlowProps() {
        return this.editor.donationFlow.properties;
      },

      unselectedActiveCustomFields() {
        const selectedFields = this.editor.donationFlow ? this.editor.donationFlow.properties.custom_fields.fields : [];
        const selectedFieldIds = selectedFields.map(field => field.id);

        return this.customFields.filter(field => {
          return !field.archived && !selectedFieldIds.includes(field.id);
        });
      },
    },
    filters: {
      dollarFormat(number) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });

        return formatter.format(number);
      },

      longFormatDate(dateString) {
        return moment(dateString).format('dddd, MMMM Do YYYY [at] h:mm:ss a');
      },
    },
    watch: {
      'activeCharityId'() {
        this.updateFlows();
      },
    },
    data() {
      return {
        donationFlows: [],
        loading: true,

        impactAmounts: [],
        customFields: [],
        editor: {
          active: false,
          disabled: false,
          isCreatingNewDonationFlow: false,
          donationFlow: null,
          donationFlowBeforeEdits: null,
          activePage: 'general',
          errors: [],
        },
        deleteDonationFlow: null,
        quillOption: {
          modules: {
            clipboard: {newLines: false},
            keyboard: {
              bindings: {
                enter: {
                  key: 13,
                  handler: function () {
                    return false;
                  }
                }
              }
            },

            "emoji-toolbar": true,
            // "emoji-textarea": true,
            "emoji-shortname": true,
            toolbar: {
              container: [
                ['bold', 'italic'],
                ['emoji', 'link'],
                ['clean'],
              ],
              handlers: {
                'emoji': function () {}
              }
            },

          }
        }
      };
    },
  };
</script>
<style lang="scss">

  .new-msg .ql-editor {
    height: auto;
    padding: 10px;
  }

  .dollar-input-wrap {
    &:before {
      content: '$';
      position: absolute;
      font-size: 16px;
      margin-top: 1px;
      height: 34px;
      border-right: 1px solid #dfe3e9;
      padding: 7px 8px 8px 12px;
    }

    input {
      padding-left: 36px;
    }
  }

  .cf-wrap {
    .guest-pill-archived {
      background-color: rgba(255, 159, 67, .15);
      color: rgb(255, 159, 67);
    }

    .d-block-list {
      .btn {
        box-shadow: none;
      }
    }

    .form-inline {
      display: inline-block;
    }

    .form-group {
      margin-bottom: 8px;
    }

    .custom-field-row {
      cursor: move;
    }

    .modal-delete {
      .no-box-shadow {
        box-shadow: none;
      }
    }


    .form-group-actions {
      .form-switch {
        display: block;
        line-height: 1.2rem;
        margin: .2rem 0;
        min-height: 1.4rem;
        position: relative;
      }
    }

    .input-group {
      display: flex;
      margin: 10px 0;

      label {
        line-height: 36px;
        padding-right: 10px;
      }

      * {
        border-radius: 0;
      }

      .btn-sm {
        width: 36px;
        padding: 1px 6px;
        box-shadow: none;
      }

      & > :last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      & > :first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      .form-control {
        flex: 1 1 auto;
        width: 1%;
      }
    }

    .tab-block {
      align-items: center;
      border-bottom: .05rem solid #e6eaee;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      margin: .5rem 0 .15rem 0;
      padding: 0;
    }

    .tab-item {
      flex: 1 0 0;
      text-align: center;

      a {
        display: block;
        font-size: 16px;
        color: #050926;
        font-weight: 400;
        padding: .4rem .2rem .3rem .2rem;
        border-bottom: .1rem solid transparent;

        &:hover {
          text-decoration: none;
        }
      }
    }

    .c-hand {
      cursor: pointer;
    }

    .tab-item.active a {
      border-bottom-color: #0d70e3;
      color: #0d70e3;
    }

  }

</style>
